import React from 'react';
import { Pressable } from 'react-native-web';
import CustomText from '../atoms/CustomText';
import { typography } from '../../utils/styling';

interface ButtonProps {
  onPress: () => void;
  label: string;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'primary' | 'secondary';
  style?: object;
  textStyle?: object;
  icon?: React.ReactNode;
  rounded?: boolean;
}

export default function Button({ 
  onPress, 
  label, 
  disabled = false, 
  loading = false,
  variant = 'primary',
  style = {},
  textStyle = {},
  icon,
  rounded = true,
}: ButtonProps) {
  const getBackgroundColor = () => {
    if (variant === 'primary') {
      return '#1BA465';  // Always use primary color, opacity handled in style
    }
    return '#E2E8F0';
  };

  const getTextColor = () => {
    if (variant === 'primary') {
      return 'white';
    }
    return disabled ? '#A0AEC0' : '#4A5568';
  };

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled || loading}
      style={{
        backgroundColor: getBackgroundColor(),
        height: 48,
        borderRadius: rounded ? 100 : 6,
        justifyContent: 'center',
        alignItems: 'center',
        opacity: (disabled || loading) ? 0.5 : 1,
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        flexDirection: 'row',
        gap: 6,
        ...style,
      }}
    >
      {icon}
      <CustomText style={{ 
        color: getTextColor(),
        fontWeight: '600',
        fontFamily: typography.fontFamily.heading,
        ...textStyle,
      }}>
        {label}
      </CustomText>
    </Pressable>
  );
} 